interface AnamnesisHistoryItem {
	RESPOSTA_ANAMNESE_V7_CONCLUIDO?: string;
}

interface QuestionnaireHistory {
	sf36?: unknown[];
	anamneses?: AnamnesisHistoryItem[];
}

export function hasQualityOfLifeHistory(
	history?: QuestionnaireHistory | null
): boolean {
	return (history?.sf36?.length ?? 0) > 0;
}

export function hasNoIncompleteAnamneses(
	history?: QuestionnaireHistory | null
): boolean {
	const hasIncomplete = history?.anamneses?.some(
		(item) => item.RESPOSTA_ANAMNESE_V7_CONCLUIDO === "N"
	);

	return !hasIncomplete;
}
